import { TYPE_COLORS_BG, TYPE_COLORS_FG, TYPE_LABELS } from '../constants';
import type { UpdateType } from '../types';

export function TypeBadge({ type }: { type: UpdateType }) {
  return (
    <span
      style={{
        fontSize: 10,
        fontWeight: 700,
        letterSpacing: 0.5,
        padding: '2px 8px',
        borderRadius: 3,
        textTransform: 'uppercase',
        whiteSpace: 'nowrap',
        background: TYPE_COLORS_BG[type] ?? '#F3F2F1',
        color: TYPE_COLORS_FG[type] ?? '#605E5C',
      }}
    >
      {TYPE_LABELS[type] ?? type}
    </span>
  );
}
